"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var http = require("http");

var https = require("https");

var _require = require("stream"),
    Writable = _require.Writable;

var zlib = require("zlib");

var ver = process.version.replace("v", "").split(".");
var majorNodeVersion = Number.parseInt(ver[0]);

function abortRequest(clientRequest) {
  // clientRequest.destroy breaks the test suite for versions 10 and 12,
  // hence the version check
  if (majorNodeVersion > 13) {
    clientRequest.destroy();
  } else {
    clientRequest.abort();
  }

  clientRequest.removeAllListeners();
  clientRequest.on("error", function () {});
}

module.exports =
/*#__PURE__*/
function (_Writable) {
  _inherits(Request, _Writable);

  function Request(url, clientOptions, requestOptions) {
    var _this;

    _classCallCheck(this, Request);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Request).call(this));
    Object.assign(_assertThisInitialized(_this), clientOptions);
    _this.currentURL = url;
    _this._requestOptions = requestOptions;
    _this.headers = requestOptions.headers;
    _this._ended = false;
    _this._redirectCount = 0;
    _this._requestBodyBuffers = [];
    _this._bufferIndex = 0;

    _this._performRequest();

    return _this;
  }

  _createClass(Request, [{
    key: "abort",
    value: function abort() {
      abortRequest(this._currentRequest);
      this.emit("abort");
      this.removeAllListeners();
    }
  }, {
    key: "pipeRequest",
    value: function pipeRequest(form) {
      form.pipe(this._currentRequest);
    }
  }, {
    key: "write",
    value: function write(data, encoding) {
      if (data.length > 0) {
        this._requestBodyBuffers.push({
          data: data,
          encoding: encoding
        });

        this._currentRequest.write(data, encoding);
      }
    }
  }, {
    key: "end",
    value: function end() {
      this.emit("request", this._currentRequest);
      this._ended = true;

      this._currentRequest.end();
    }
  }, {
    key: "setHeader",
    value: function setHeader(name, value) {
      this.headers[name] = value;

      this._currentRequest.setHeader(name, value);
    }
  }, {
    key: "removeHeader",
    value: function removeHeader(name) {
      delete this.headers[name];

      this._currentRequest.removeHeader(name);
    } // Without this method, the test send-redirect-infinite-sync will halt the test suite
    // TODO: investigate this further and ideally remove

  }, {
    key: "toJSON",
    value: function toJSON() {
      var _this$_requestOptions = this._requestOptions,
          method = _this$_requestOptions.method,
          headers = _this$_requestOptions.headers;
      return {
        uri: new URL(this.currentURL),
        method: method,
        headers: headers
      };
    }
  }, {
    key: "_writeNext",
    value: function _writeNext(error) {
      if (this._currentRequest) {
        if (error) {
          this.emit("error", error);
        } else if (this._bufferIndex < this._requestBodyBuffers.length) {
          var buffer = this._requestBodyBuffers[this._bufferIndex++];

          if (!this._currentRequest.writableEnded) {
            this._currentRequest.write(buffer.data, buffer.encoding, this._writeNext.bind(this));
          }
        } else if (this._ended) {
          this._currentRequest.end();
        }
      }
    }
  }, {
    key: "_performRequest",
    value: function _performRequest() {
      var _this2 = this;

      var urlOptions = new URL(this.currentURL);
      var scheme = urlOptions.protocol;
      this._requestOptions.agent = this.agents[scheme.substring(0, scheme.length - 1)];

      var _ref = scheme === "https:" ? https : http,
          request = _ref.request;

      this._currentRequest = request(this.currentURL, this._requestOptions, function (response) {
        _this2._processResponse(response);
      });
      var cookies;

      if (this._redirectCount === 0) {
        this.originalCookieHeader = this.getHeader("Cookie");
      }

      if (this.cookieJar) {
        cookies = this.cookieJar.getCookieStringSync(this.currentURL);
      }

      if (cookies && cookies.length) {
        if (this.originalCookieHeader) {
          this.setHeader("Cookie", this.originalCookieHeader + "; " + cookies);
        } else {
          this.setHeader("Cookie", cookies);
        }
      }

      var _loop = function _loop() {
        var event = _arr[_i];

        _this2._currentRequest.on(event, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
      };

      for (var _i = 0, _arr = ["connect", "error", "socket", "timeout"]; _i < _arr.length; _i++) {
        _loop();
      }

      if (this._isRedirect) {
        this._bufferIndex = 0;

        this._writeNext();
      }
    }
  }, {
    key: "_processResponse",
    value: function _processResponse(response) {
      var _this3 = this;

      var cookies = response.headers["set-cookie"];

      if (this.cookieJar && Array.isArray(cookies)) {
        try {
          cookies.forEach(function (cookie) {
            _this3.cookieJar.setCookieSync(cookie, _this3.currentURL, {
              ignoreError: true
            });
          });
        } catch (e) {
          this.emit("error", e);
        }
      }

      var statusCode = response.statusCode;
      var location = response.headers.location; // In Node v15, aborting a message with remaining data causes an error to be thrown,
      // hence the version check

      var catchResErrors = function catchResErrors(err) {
        if (!(majorNodeVersion >= 15 && err.message === "aborted")) {
          _this3.emit("error", err);
        }
      };

      response.on("error", catchResErrors);
      var redirectAddress = null;
      var resendWithAuth = false;

      if (typeof location === "string" && location.length && this.followRedirects && statusCode >= 300 && statusCode < 400) {
        redirectAddress = location;
      } else if (statusCode === 401 && /^Basic /i.test(response.headers["www-authenticate"] || "") && this.user && this.user.length) {
        this._requestOptions.auth = "".concat(this.user, ":").concat(this.pass);
        resendWithAuth = true;
      }

      if (redirectAddress || resendWithAuth) {
        if (++this._redirectCount > 21) {
          var redirectError = new Error("Maximum number of redirects exceeded");
          redirectError.code = "ERR_TOO_MANY_REDIRECTS";
          this.emit("error", redirectError);
          return;
        }

        abortRequest(this._currentRequest);
        response.destroy();
        this._isRedirect = true;

        if ((statusCode === 301 || statusCode === 302) && this._requestOptions.method === "POST" || statusCode === 303 && !/^(?:GET|HEAD)$/.test(this._requestOptions.method)) {
          this._requestOptions.method = "GET";
          this._requestBodyBuffers = [];
        }

        var previousHostName = this._removeMatchingHeaders(/^host$/i);

        if (!previousHostName) {
          previousHostName = new URL(this.currentURL).hostname;
        }

        var previousURL = this.currentURL;

        if (!resendWithAuth) {
          var nextURL = redirectAddress.startsWith("https:") ? new URL(redirectAddress) : new URL(redirectAddress, this.currentURL);

          if (nextURL.hostname !== previousHostName) {
            this._removeMatchingHeaders(/^authorization$/i);
          }

          this.currentURL = nextURL.toString();
        }

        this.headers.Referer = previousURL;
        this.emit("redirect", response, this.headers, this.currentURL);

        try {
          this._performRequest();
        } catch (cause) {
          this.emit("error", cause);
        }
      } else {
        var pipeline = response;
        var acceptEncoding = this.headers["Accept-Encoding"];
        var requestCompressed = typeof acceptEncoding === "string" && (acceptEncoding.includes("gzip") || acceptEncoding.includes("deflate"));

        if (requestCompressed && this._requestOptions.method !== "HEAD" && statusCode >= 200 && statusCode !== 204 && statusCode !== 304) {
          var zlibOptions = {
            flush: zlib.constants.Z_SYNC_FLUSH,
            finishFlush: zlib.constants.Z_SYNC_FLUSH
          };
          var contentEncoding = (response.headers["content-encoding"] || "identity").trim().toLowerCase();

          if (contentEncoding === "gzip") {
            pipeline = zlib.createGunzip(zlibOptions);
            response.pipe(pipeline);
          } else if (contentEncoding === "deflate") {
            pipeline = zlib.createInflate(zlibOptions);
            response.pipe(pipeline);
          }
        }

        pipeline.removeAllListeners("error");
        this.emit("response", response, this.currentURL);
        pipeline.on("data", function (bytes) {
          return _this3.emit("data", bytes);
        });
        pipeline.once("end", function (bytes) {
          return _this3.emit("end", bytes);
        });
        pipeline.on("error", catchResErrors);
        pipeline.on("close", function () {
          return _this3.emit("close");
        });
        this._requestBodyBuffers = [];
      }
    }
  }, {
    key: "getHeader",
    value: function getHeader(key, value) {
      if (this._currentRequest) {
        return this._currentRequest.getHeader(key, value);
      }

      return null;
    }
  }, {
    key: "_removeMatchingHeaders",
    value: function _removeMatchingHeaders(regex) {
      var lastValue;

      for (var header in this.headers) {
        if (regex.test(header)) {
          lastValue = this.headers[header];
          delete this.headers[header];
        }
      }

      return lastValue;
    }
  }]);

  return Request;
}(Writable);